/// <amd-module name="Wit/QueriesHub/ContributedTabView/ContributedTabView" />
import * as React from "react";
import { getTFSPageData } from "Tfs/Platform/Page";
import { ObservableCollection } from "VSS/Core/Observable";
import { IPageStateHistoryService } from "VSS/Features/History";
import { addTabs } from "VSS/Features/PlatformUI/ContributedTab";
import { Components, IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { Page } from "VSSUI/Page";
import { Surface, SurfaceBackground } from "VSSUI/Surface";
import { IVssContributedTab, TabContent } from "VSSUI/Tabs";
import { IQueryService } from "Wit/Common/QueryService/IQueryService";
import { QueryHeader } from "Wit/QueriesHub/Common/Components/QueryHeader";
import { IQueryContext } from "Wit/QueriesHub/Common/Interfaces";
import { QueryUtils } from "Wit/QueriesHub/Common/Utils/QueryUtils";

export class ContributedTabView extends VssComponent {
    private queryService: IQueryService;
    private tabId: string;
    private contributedTabs: ObservableCollection<IVssContributedTab>;
    private tabContext: { query?: IQueryContext } = {};

    constructor(props: any, context: IVssComponentContext) {
        super(props, context);

        this.queryService = context.pageContext.getService<IQueryService>("IQueryService");
        const pageStateHistoryService = this.context.pageContext.getService<IPageStateHistoryService>("IPageStateHistoryService");
        const state = pageStateHistoryService.getProjectedState();
        this.tabId = state["view"];
        this.getTabContext();
        this.contributedTabs = new ObservableCollection<IVssContributedTab>();
    }

    private getTabContext = async () => {
        const projectId = getTFSPageData(this.context.pageContext)?.project?.id ?? "";
        this.tabContext.query = await QueryUtils.getQueryContext(this.queryService, projectId);
        addTabs(this.context.pageContext, this.contributedTabs, "ms.vss-work-web.query-tabs", { contextualData: this.tabContext });
    };

    public render(): JSX.Element {
        return (
            <Surface background={SurfaceBackground.neutral}>
                <Page className="flex-grow flex-column" selectedTabId={this.tabId} tabProviders={this.contributedTabs}>
                    <QueryHeader selectedTabId={this.tabId} />
                    <TabContent />
                </Page>
            </Surface>
        );
    }
}

Components.add("query-contributed-tab-component", ContributedTabView);
